import { staticLabels } from './staticLabels';
import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
export function getLabel(key) {
  return staticLabels[key] || I18n.text(`developer-docs-source.labels.${key}`);
}
export function labelExists(key) {
  return staticLabels[key] || isValidI18nKey(`developer-docs-source.labels.${key}`);
}